@let rev = revision();
@let ls = letsikring();
<div [formGroup]="form()">
  <div class="detail-section-header">Stamoplysninger</div>

  <app-detail-row [editMode]="editMode()" label="ITC Letsikring id">
    {{ ls.itcLetsikringId }}
    <ng-template #editor
      ><input pInputText formControlName="itcLetsikringId"
    /></ng-template>
  </app-detail-row>

  <app-detail-row [editMode]="editMode()" label="Letsikrings nr."
    >{{ ls.letsikringNr }}
  </app-detail-row>

  <app-detail-row [editMode]="editMode()" label="Ekstern reference"
    >{{ ls.eksternReference }}
    <ng-template #editor
      ><input pInputText formControlName="eksternReference"
    /></ng-template>
  </app-detail-row>

  <app-detail-row [editMode]="editMode()" label="Leverandør"
    >{{ ls.leverandoer }}
  </app-detail-row>

  <section formGroupName="gaeldendeRevision">
    @if (!editMode()) {
      <app-detail-row [editMode]="editMode()" label="Ændringskommentar"
        >{{ rev.kommentar }}
      </app-detail-row>
      <app-detail-row [editMode]="editMode()" label="Revisions nr."
        >{{ rev.revisionNr }}
      </app-detail-row>
      <app-detail-row [editMode]="editMode()" label="Oprettet/ændret af"
        >{{ rev.oprettetAf }}
      </app-detail-row>
      <app-detail-row [editMode]="editMode()" label="Ændringsdato"
        >{{ rev.oprettelsesDato | date: 'dd-MM-yyyy HH:mm' }}
      </app-detail-row>
      <app-detail-row [editMode]="editMode()" label="Oprettet via"
        >{{ rev.oprettelsesKilde }}
      </app-detail-row>
    }

    <app-detail-row [editMode]="editMode()" label="Annulleret"
      >{{ rev.annulleret | boolean }}
      <ng-template #help>
        Når kunden fortryder aftalen kan den registreres som annulleret ved at
        det markeres i checkboksen.<br /><br />

        Husk samtidig at angive korrekt hændelseskode, og kontroller at der
        tilbagebetales korrekt præmie til kunden (beløb skal have negativt
        fortegn).<br /><br />

        Annullerede aftaler vises for kunden som 'Udgåede aftaler'<br /><br />
      </ng-template>
    </app-detail-row>

    <app-detail-row [editMode]="editMode()" label="Ikrafttrædelse"
      >{{ rev.ikrafttraedelse | date: 'dd-MM-yyyy' }}
      <ng-template #editor>
        <app-let-date-picker formControlName="ikrafttraedelse" />
      </ng-template>
    </app-detail-row>

    <app-detail-row [editMode]="editMode()" label="Hændelseskode"
      >{{ rev.haendelsesKode }}
      <ng-template #editor>
        <p-input-number
          formControlName="haendelsesKode"
          locale="da"
          [maxFractionDigits]="0"
          [maxlength]="2"
          mode="decimal" />
      </ng-template>
      <ng-template #help>
        Hændelseskoden angiver den aktuelle hændelse foretaget for Letsikringen,
        og skal altid angives til én af nedenstående værdier.
        <br /><br />

        Ved ændringer angives hovedårsagen til ændringen, mens der kan foretages
        flere samtidige ændringer (forhøjelse + skift af kontonummer, for
        eksempel).
        <br /><br />

        Ved flere samtidige ændringer vælges den første kode i listen der
        passer.
        <br /><br />
        Følgende koder benyttes:<br /><br />

        Hovedforløb:<br />
        1: Oprettet<br />
        2: Udbetaling<br /><br />

        Ændringer:<br />
        20: Opsigelse<br />
        21: Annullering / Fortryd<br />
        22: Ændring af betaling via overløbsrate<br />
        23: Ændring af betaling<br />
        24: Supplerende engangsbetaling<br />
        25: Ændring af depotsikring<br />
        26: Overførsel til<br />
        27: Ændring af udbetalingsdato<br />
        29: Opsigelse af LTS<br />
        50: Tilbagekøb af aftale<br />
        99: Ændring i.f.m. fejlrettelse<br /><br />

        Hændelser - forsikrede:<br />
        30: Død<br />
        31: Overført ud<br /><br />

        Hændelser - andre:<br />
        42: Årsregulering<br />
        43: Prisregulering<br />
        46: Konvertering<br />
      </ng-template>
    </app-detail-row>

    @let letsikringRisiko = risiko();
    @if (letsikringRisiko) {
      <div formGroupName="letsikringRisiko">
        <app-detail-row [editMode]="editMode()" label="Opsigelses dato"
          >{{ letsikringRisiko.opsigelsesDato | date: 'dd-MM-yyyy' }}
          <ng-template #editor>
            <app-let-date-picker formControlName="opsigelsesDato"
          /></ng-template>
        </app-detail-row>
      </div>
    }

    @let letsikringAfIndtaegt = livrente();
    @if (letsikringAfIndtaegt) {
      <div formGroupName="letsikringAfIndtaegt">
        <app-detail-row
          [editMode]="editMode()"
          label="Oprindelig oprettelsesdato"
          >{{ letsikringAfIndtaegt.oprettelsesDato | date: 'dd-MM-yyyy' }}
          <ng-template #editor>
            <app-let-date-picker formControlName="oprettelsesDato"
          /></ng-template>
        </app-detail-row>

        <app-detail-row [editMode]="editMode()" label="PFA tilstandskode"
          >{{ letsikringAfIndtaegt.tilstand }}
          <ng-template #editor
            ><input pInputText formControlName="tilstand"
          /></ng-template>
          <ng-template #help>
            Angivelse af tilstanden for Letsikringen, sker med følgende mulige
            værdier:<br /><br />

            1: Løbende betaling<br />
            2: Fripolice<br />
            3: Henstand<br />
            4: Orlov<br />
            5: Annulleret<br />
            6: Tilbagekøbt<br />
            7: Overført ud<br />
            8: Aktuel<br />
            9: Stop<br />
            10: Under lukning<br />
            11: Midlertidig indbetalingssikring<br />
            12: Overført Sammenlægning<br />
          </ng-template>
        </app-detail-row>

        <app-detail-row [editMode]="editMode()" label="PFA stop-årsagskode"
          >{{ letsikringAfIndtaegt.stopAarsag }}
          <ng-template #editor
            ><input pInputText formControlName="stopAarsag"
          /></ng-template>
          <ng-template #help>
            Angivelse af stop årsag for Letsikringen, sker med følgende mulige
            værdier:<br /><br />

            1: Kritisk sygdom<br />
            2: Helbredssikring<br />
            3: PFA Forebygger<br />
            4: Tab af erhvervsevne<br />
            5: Dødsfald<br />
            6: Tilbageløb<br />
            7: Overførsel ud<br />
            8: Pensionering<br />
            9: Intern reserveoverførsel<br />
            10:&lt;Blank&gt;<br />
          </ng-template>
        </app-detail-row>

        <app-detail-row [editMode]="editMode()" label="Unisex"
          >{{ letsikringAfIndtaegt.unisex | boolean }}
          <ng-template #editor>
            <p-checkbox formControlName="unisex" [binary]="true" />
          </ng-template>
        </app-detail-row>

        <app-detail-row [editMode]="editMode()" label="Pensionsreform"
          >{{ getPensionsreformText(letsikringAfIndtaegt.pensionsreform) }}
          <ng-template #editor>
            <p-select
              [options]="pensionsreformOptions"
              formControlName="pensionsreform"
              optionLabel="text"
              optionValue="value"
              appendTo="body" />
          </ng-template>
        </app-detail-row>

        <app-detail-row [editMode]="editMode()" label="Tegningsmåde"
          >{{ letsikringAfIndtaegt.tegningsmaade }}
          <ng-template #editor
            ><p-select
              [options]="tegningsmaadeOptions"
              formControlName="tegningsmaade"
              optionLabel="value"
              optionValue="value"
              appendTo="body"
          /></ng-template>
        </app-detail-row>
      </div>
    }
  </section>
</div>
